import { IRichMenuConditionSetting, IRichMenuRequest } from '@/utils/types'
import { NormApi } from './norm'

export class RichMenuConditionSettingApi extends NormApi<IRichMenuConditionSetting> {
  single = async (params: IRichMenuRequest) => {
    const response = await this.axios.get('/v1/rich-menu-condition-setting', {
      params,
    })
    return this.responseHandler(response)
  }

  add = async (payload: IRichMenuConditionSetting) => {
    const response = await this.axios.post('/v1/rich-menu-condition-setting', payload)
    return this.responseHandler(response)
  }

  update = async (payload: IRichMenuConditionSetting) => {
    const { _id, ...updateData } = payload
    const response = await this.axios.put(`/v1/rich-menu-condition-setting/${_id}`, updateData)
    return this.responseHandler(response)
  }

  active = async (payload: IRichMenuConditionSetting) => {
    const response = await this.axios.post(`/v1/rich-menu-condition-setting/${payload._id}/active`, payload)
    return this.responseHandler(response)
  }
}

const richMenuConditionSettingApi = new RichMenuConditionSettingApi()
export default richMenuConditionSettingApi
